export default {
    'zh_CN': {
        'property.watering.id.label': '主键',
        'property.watering.id.holder': '请输入主键',
        
        
        'property.watering.id.required': '主键必填',
        'property.watering.areaId.label': '浇灌区域',
        'property.watering.areaId.holder': '请输入浇灌区域',
        
        
        'property.watering.areaId.required': '浇灌区域必填',
        'property.watering.wateringTime.label': '浇灌时间',
        'property.watering.wateringTime.holder': '请输入浇灌时间',
        'property.watering.wateringTime.required': '浇灌时间必填',
        'property.watering.wateringPeople.label': '浇灌人',
        'property.watering.wateringPeople.holder': '请输入浇灌人',
        
        
        'property.watering.wateringPeople.required': '浇灌人必填',
        'property.watering.remark.label': '备注',
        'property.watering.remark.holder': '请输入备注',
        'property.watering.remark.max': '备注最多255个字符',
        
        'property.watering.remark.required': '备注必填',
        'property.watering.createTime.label': '创建日期',
        'property.watering.createTime.holder': '请输入创建日期',
        'property.watering.createTime.required': '创建日期必填',
        'property.watering.updateTime.label': '修改日期',
        'property.watering.updateTime.holder': '请输入修改日期',
        'property.watering.updateTime.required': '修改日期必填',
        'property.watering.isDelete.label': '是否删除',
        'property.watering.isDelete.holder': '请输入是否删除',
        
        
        'property.watering.isDelete.dictionary': ()=>[{value:0,label:'删除'}],
        'property.watering.isDelete.required': '是否删除必填'
    },
    'zh_TW': {
        'property.watering.id.label': '主键',
        'property.watering.id.holder': '請輸入主键',
        
        
        'property.watering.id.required': '主键必填',
        'property.watering.areaId.label': '浇灌区域',
        'property.watering.areaId.holder': '請輸入浇灌区域',
        
        
        'property.watering.areaId.required': '浇灌区域必填',
        'property.watering.wateringTime.label': '浇灌时间',
        'property.watering.wateringTime.holder': '請輸入浇灌时间',
        
        
        'property.watering.wateringTime.required': '浇灌时间必填',
        'property.watering.wateringPeople.label': '浇灌人',
        'property.watering.wateringPeople.holder': '請輸入浇灌人',
        
        
        'property.watering.wateringPeople.required': '浇灌人必填',
        'property.watering.remark.label': '备注',
        'property.watering.remark.holder': '請輸入备注',
        
        
        'property.watering.remark.required': '备注必填',
        'property.watering.createTime.label': '创建日期',
        'property.watering.createTime.holder': '請輸入创建日期',
        
        
        'property.watering.createTime.required': '创建日期必填',
        'property.watering.updateTime.label': '修改日期',
        'property.watering.updateTime.holder': '請輸入修改日期',
        
        
        'property.watering.updateTime.required': '修改日期必填',
        'property.watering.isDelete.label': '是否删除',
        'property.watering.isDelete.holder': '請輸入是否删除',
        
        
        'property.watering.isDelete.required': '是否删除必填'
    },
    'en_US': {
        'property.watering.id.label': 'id',
        'property.watering.id.holder': 'Enter id',
        'property.watering.id.max': 'id max length: 主键',
        
        
        'property.watering.id.required': 'id required',
        'property.watering.areaId.label': 'areaId',
        'property.watering.areaId.holder': 'Enter areaId',
        'property.watering.areaId.max': 'areaId max length: 浇灌区域',
        
        
        'property.watering.areaId.required': 'areaId required',
        'property.watering.wateringTime.label': 'wateringTime',
        'property.watering.wateringTime.holder': 'Enter wateringTime',
        'property.watering.wateringTime.max': 'wateringTime max length: 浇灌时间',
        
        
        'property.watering.wateringTime.required': 'wateringTime required',
        'property.watering.wateringPeople.label': 'wateringPeople',
        'property.watering.wateringPeople.holder': 'Enter wateringPeople',
        'property.watering.wateringPeople.max': 'wateringPeople max length: 浇灌人',
        
        
        'property.watering.wateringPeople.required': 'wateringPeople required',
        'property.watering.remark.label': 'remark',
        'property.watering.remark.holder': 'Enter remark',
        'property.watering.remark.max': 'remark max length: 备注',
        
        
        'property.watering.remark.required': 'remark required',
        'property.watering.createTime.label': 'createTime',
        'property.watering.createTime.holder': 'Enter createTime',
        'property.watering.createTime.max': 'createTime max length: 创建日期',
        
        
        'property.watering.createTime.required': 'createTime required',
        'property.watering.updateTime.label': 'updateTime',
        'property.watering.updateTime.holder': 'Enter updateTime',
        'property.watering.updateTime.max': 'updateTime max length: 修改日期',
        
        
        'property.watering.updateTime.required': 'updateTime required',
        'property.watering.isDelete.label': 'isDelete',
        'property.watering.isDelete.holder': 'Enter isDelete',
        'property.watering.isDelete.max': 'isDelete max length: 是否删除',
        
        
        'property.watering.isDelete.required': 'isDelete required'
    }
}
